import { render, staticRenderFns } from "./PersonsOverview.vue?vue&type=template&id=1596cd41&scoped=true&lang=html&"
import script from "./PersonsOverview.vue?vue&type=script&lang=js&"
export * from "./PersonsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596cd41",
  null
  
)

export default component.exports